import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchS3File } from './actions';
import { FileState } from './types';

const initialState: FileState = {
  loading: false,
  error: null,
  fileBlob: null,
};

export const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    clearFile: (state) => {
      state.fileBlob = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchS3File.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.fileBlob = null;
      })
      .addCase(fetchS3File.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.fileBlob = action.payload;
      })
      .addCase(fetchS3File.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export const { clearFile } = fileSlice.actions;
export const fileReducer = fileSlice.reducer;
